import axios from 'axios'

export const getLoketLogs = () => axios.get(`${process.env.REACT_APP_API_URL}/logs/loket`)
